import { lazy } from 'react';

export default [
    {
        path: '/landing-page-3d',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'LandingPage3DLayout' */ './layout')),
    },
];
